import React from 'react'
import { EmailField } from '@payloadcms/plugin-form-builder/types';
import { UseFormRegister, FieldValues, FieldErrorsImpl } from 'react-hook-form'
import { Error } from '../Error'
import { Width } from '../Width'

import classes from './index.module.scss'

export const Email: React.FC<
  EmailField & {
    register: UseFormRegister<FieldValues & any>
    errors: Partial<
      FieldErrorsImpl<{
        [x: string]: any
      }>
    >
  }
> = ({ name, width, label, register, required: requiredFromProps, errors }) => {
  return (
    <Width width={width ? width.toString() : undefined}>
      <div className={classes.wrap}>
        <input
          type="text"
          className={classes.input}
          id={name}
          placeholder={label}
          {...register(name, { required: requiredFromProps, pattern: /^\S+@\S+$/i })}
        />
        <label htmlFor={name} className={classes.label}>
          {label}
        </label>
        {requiredFromProps && errors[name] && <Error />}
      </div>
    </Width>
  )
}
